<template>
  <div class="row">
    <!-- main title -->
    <div class="col-12">
      <div class="main__title">
        <h2>لیست اپیزودهای بدون منبع</h2>
      </div>
    </div>
    <!-- end main title -->
    <!-- form -->
    <div class="col-12">

      <div class="row">
        <!-- main title -->
        <!-- end main title -->

        <CButton @click="duplicate_item_dialog(item)" v-if="checkbox_items.length>0"
                 class="main__table-btn main__table-btn--delete open-modal pointer">
          افزودن منبع
        </CButton>
        انتخاب شده ها ({{checkbox_items.length}})
        <CButton @click="checkbox_items=[]"
                 class="main__table-btn main__table-btn--delete open-modal pointer">
          عدم انتخاب
        </CButton>
        <!-- users -->
        <div class="col-12">
          <Datatable
              :items="items"
              :fields="fields"
              title="لیست فیلم ها"
              :items-per-page="20"
              hover
              height="300px"
              border
              striped
              sorter
              column-filter
              pagination
          >
            <template #row="{item,index}">
              <td>
                <div class="main__table-text">{{ index + 1 }}</div>
              </td>
            </template>
            <template #name="{item}">
              <td>
                <div class="main__table-text">
                  {{item.name}}
                </div>
              </td>
            </template>
            <template #season="{item}">
              <td>
               {{item.season.name}}
              </td>
            </template>
            <template #poster="{item}">
              <td>
<!--                {{item.season.poster.name}}-->

              </td>
            </template>


            <template #operation="{item}">
              <td>
                <div class="main__table-btns">

                 <input type="checkbox" v-model="checkbox_items" :value="item.id" />
                </div>
              </td>
            </template>
          </Datatable>

        </div>


      </div>
    </div>
    <CModal v-model="duplicate_dialog" title="منابع">
      <div class="text-white">
        <div class="col-span-12 grid grid-cols-12 gap-4">

          <div class="col-span-8">
            <treeselect
                :async="true"
                @select="select_url"
                :load-options="load_uploader"
                :normalizer="normalizer_uploader"
                placeholder="جستجو لینک"
                :searchable="true"
                :load-root-options="true"
                :auto-load-root-options="true"
                :clear-on-select="false"
                :show-count="true"
                :always-open="false"
                :default-expand-level="1"
                :min-input-length="0"
                :delay="0"
                :loading-text="'در حال جستجو...'"
                :no-options-text="'موردی یافت نشد'"
                :no-results-text="'موردی یافت نشد'"
            />
            <input v-model="sourceData.link"
                   type="text"
                   class="form__input mt-3"
                   style="direction: ltr;font-family: Arial !important;"
                   placeholder="لینک منبع">
          </div>

          <button type="button"
                  class="form__btn col-span-4 "
                  @click="send_episodes_source()">
            افزودن
          </button>

        </div>


      </div>
      <div class="flex">
<!--        <CButton @click="duplicate_item()">تایید</CButton>-->
        <CButton @click="duplicate_dialog=false">انصراف</CButton>
      </div>

    </CModal>
    <!-- end form -->
  </div>
</template>

<script>
import axios from "axios";
// import {bus} from '../main';
import Datatable from "@/views/customTable/Datatable";
import CModal from "@/views/CustomComponent/CModal.vue";
import CButton from "@/views/CustomComponent/CButton.vue";
import Treeselect, {ASYNC_SEARCH} from 'vue3-treeselect'
import 'vue3-treeselect/dist/vue3-treeselect.css'
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  name: 'ItemsList',
  data() {
    return {
      duplicate_dialog: false,
      duplicate_id: 0,
      items: [],
      checkbox_items: [],
      selected_episode:{},
      fields: [
        {key: 'row', label: 'ردیف', _style: 'width:5%'},
        {key: 'name', label: 'نام', _style: 'width:5%'},
        {key: 'season', label: 'فصل', _style: 'width:5%'},
        {key: 'poster', label: 'ویدئو', _style: 'width:5%'},

        {key: 'operation', label: 'عملیات', _style: 'width:5%'}
      ],
      status_form: 0,
      name: '',
      sourceData: {
        link: '',
        editMode: false,
        editId: null
      },
      load_uploader({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            axios.post('search_upload_video', {
              search: searchQuery,

            }).then(function (response) {
              options = response.data;
              callback(null, options);
              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_uploader(node) {
        return {
          id: node.id,
          label: node.title,
        }
      },
    }
  },
  components: {
    Treeselect,
    CButton,
    CModal,
    Datatable
  },
  mounted() {
    this.get_data();
  },
  methods: {
    select_url(node, id) {
      this.sourceData.link = node.url
    },
    duplicate_item_dialog(item) {
      this.selected_episode = item
      this.duplicate_dialog = true
    },
    duplicate_item() {
      return false;
      var self = this
      var formData = new FormData();
      formData.append("id", this.duplicate_id)


      this.axios.post('duplicate_item', formData, {}).then(function (response) {
        self.get_data()

      }).catch(function (error) {
        console.log(error);
        self.$toast.error('خطا از سرور');

      });
    },
    get_data() {

      var self = this;

      var formData = new FormData();

      this.axios.post('get_unsourced_episodes', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.items = content_data

      }).catch(function (error) {
        console.log(error);
      });


    },
    delete_item(item) {

      var self = this;

      var formData = new FormData();
      formData.append("id", item.id);
      this.axios.post('delete_poster', formData, {}).then(function (response) {

        self.items.filter(x => x.id == item.id)[0].view_status = 4;
        // items = content_cats.orders;

      }).catch(function (error) {
        console.log(error);
      });


    },
    send_episodes_source(){
      for(var i=0;i<this.checkbox_items.length;i++){
        this.handleSourceSubmit(this.checkbox_items[i])
      }
      this.checkbox_items=[]
    },
    async handleSourceSubmit(index) {
      if (!this.sourceData.link.trim()) {
        this.$toast.error('لطفا لینک را وارد کنید');
        return;
      }

      this.isLoading = true;
      try {
        const formData = new FormData()
        formData.append('link', this.sourceData.link)
        // formData.append('episode_id', this.selected_episode.id)
        formData.append('episode_id', index)

        const url = 'insert_episode_source'

        if (this.sourceData.editMode) {
          formData.append('id', this.sourceData.editId)
        }

        await this.axios.post(url, formData)

        // await this.loadSources()
        // this.resetSourceForm()
        this.$toast.success('عملیات با موفقیت انجام شد')
      } catch (error) {
        console.error(error)
        this.$toast.error('خطا در ثبت اطلاعات')
      } finally {
        this.isLoading = false;
      }
    },

  }
}
</script>

